import { render, staticRenderFns } from "./PaymentChannel.vue?vue&type=template&id=c6fb2bde"
import script from "./PaymentChannel.vue?vue&type=script&lang=js"
export * from "./PaymentChannel.vue?vue&type=script&lang=js"
import style0 from "./PaymentChannel.vue?vue&type=style&index=0&id=c6fb2bde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports